import React, { useState } from "react";
import { Box, Container, Grid, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import faqImage from "../../../assets/project-overflow.jpg"; // Replace with actual image

const faqs = [
    {
        question: "Brief and scope",
        answer: "Specify your scale and service mix (e.g., 50 lofts + design package for ASHP)",
    },
    {
        question: "Crew deployment",
        answer: "We deploy installers and supervisors",
    },
    {
        question: "Design and planning",
        answer: "For ASHP/solar PV, we deliver retrofit designs, calculations and compliance bundles",
    },
    {
        question: "Installation and oversight",
        answer: "On-site execution, while supervisors monitor quality in real-time and capture evidence",
    },
    {
        question: "Handover",
        answer: "Final EPC/RdSAP issued, TrustMark documentation lodged, defect-check readiness",
    },
    {
        question: 'Aftercare',
        answer: 'We are available to participate in audits. Post-install checks and compliance reviews'
    }
];

const FAQ = () => {
    const [expanded, setExpanded] = useState<number | null>(0);

    const handleChange = (index: number) => {
        setExpanded(expanded === index ? null : index);
    };

    return (
        <Box sx={{ py: 10, backgroundColor: "#003333" }}>
            <Container maxWidth="lg">
                <Grid container spacing={5} alignItems="center">
                    {/* Left Side - Image & Title */}
                    <Grid item xs={12} md={5}>
                        <Typography variant="h3" sx={{ fontWeight: "bold", color: "#fff", mt: 1, fontSize: { xs: '2rem', md: '3rem' } }}>
                            Project workflow
                        </Typography>
                        <Box
                            component="img"
                            src={faqImage}
                            alt="FAQ Image"
                            sx={{ width: "100%", borderRadius: "10px", mt: 3 }}
                        />
                    </Grid>

                    {/* Right Side - FAQs */}
                    <Grid item xs={12} md={7}>
                        {faqs.map((faq, index) => (
                            <Accordion
                                key={index}
                                expanded={expanded === index}
                                onChange={() => handleChange(index)}
                                sx={{
                                    mb: 2,
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    "&:before": { display: "none" },
                                    boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
                                    backgroundColor: expanded === index ? "#fff" : "#f7f8fa",
                                    padding: '10px 16px'
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon sx={{ color: "#39b54a" }} />}
                                    sx={{
                                        fontWeight: expanded === index ? "bold" : "normal",
                                        // color: "#1e144f",
                                    }}
                                >
                                    <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>
                                        <span style={{ color: "#39b54a" }}>{index + 1}.</span> {faq.question}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography sx={{ color: "#555" }}>{faq.answer}</Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Grid>
                </Grid>
            </Container>
        </Box >
    );
};

export default FAQ;
